import React from 'react'

function NotFount() {
  return (
    <div className='container'>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
        <div className='row text-center mb-5'>
        <h1 className='mb-4'>404 Not Found</h1>
        <p className='mb-4'> Sorry, the page you are looking for does not exist.</p>
      </div>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
    </div>
  )
}

export default NotFount
